// DaisyUI radio wrapped in a label, so the whole row is clickable.
// Spread Formik's `useField({ type: 'radio' })` field, or pass `name`/`value`/`checked`/`onChange` directly.
const RadioButton = ({ className = '', children = null, ...inputProps }) => (
  <label className={`flex cursor-pointer items-center gap-3 ${className}`}>
    <input type="radio" className="radio radio-sm radio-primary shrink-0" {...inputProps} />
    {children}
  </label>
);

export default RadioButton;
